export const formatLocation = (jobPost: {
  facility?: {
    city?: string | null;
    state?: string | null;
  } | null;
  city?: string | null;
  stateCode?: string | null;
  remote?: boolean | null;
}) => {
  let location = "";
  if (jobPost.facility) {
    location = [jobPost.facility.city, jobPost.facility.state]
      .filter(Boolean)
      .join(", ");
  } else if (jobPost.city) {
    location = [jobPost.city, jobPost.stateCode].filter(Boolean).join(", ");
  } else if (jobPost.remote) {
    location = "Remote";
  }
  return location;
};
